/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { RestaurantMenuFragmentDoc } from '../../MenuScreen/GraphQL/Restaurant.query.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddressQueryVariables = Types.Exact<{
  addressId: Types.Scalars['ID']['input'];
}>;

export type AddressQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export type DeliveryRestaurantQueryVariables = Types.Exact<{
  input: Types.LocationByAddressInput;
}>;

export type DeliveryRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly status: Types.LocationStatus;
        readonly restaurant: {
          readonly __typename?: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly address: string;
          readonly phone: string;
          readonly isOutpost: boolean;
          readonly isAcceptingOrders: boolean;
          readonly notAcceptingOrdersReason: string;
          readonly deliveryFee: number;
          readonly flexMessage: string | null;
          readonly hours: {
            readonly __typename?: 'RestaurantHours';
            readonly formatted: string | null;
          };
          readonly menu: {
            readonly __typename?: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename?: 'MenuCategory';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly products: ReadonlyArray<{
                readonly __typename?: 'Product';
                readonly calories: number;
                readonly categoryId: string;
                readonly cost: number;
                readonly description: string;
                readonly id: string;
                readonly isModifiable: boolean;
                readonly isCustom: boolean;
                readonly customType: Types.CustomProductType | null;
                readonly isSalad: boolean;
                readonly name: string;
                readonly outOfStock: boolean;
                readonly restaurantId: string;
                readonly slug: string;
                readonly throttleItem: boolean;
                readonly asset: {
                  readonly __typename?: 'Asset';
                  readonly url: string;
                };
                readonly ingredients: ReadonlyArray<{
                  readonly __typename?: 'Ingredient';
                  readonly id: string;
                  readonly name: string;
                  readonly asset: {
                    readonly __typename?: 'Asset';
                    readonly url: string;
                  };
                }>;
                readonly label: {
                  readonly __typename?: 'ProductLabel';
                  readonly id: string;
                  readonly name: string;
                } | null;
                readonly dietaryProperties: ReadonlyArray<{
                  readonly __typename?: 'DietaryProperty';
                  readonly id: string;
                  readonly name: Types.DietaryPropertyKind;
                }>;
              }>;
            }>;
          };
        };
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const addressQueryMock: ExecutionResult<AddressQuery> = {
  data: {
    address: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      street: 'Hello World',
      secondaryStreet: 'Hello World',
      city: 'Hello World',
      state: 'Hello World',
      country: 'Hello World',
      zipCode: 'Hello World',
      deliveryPreference: 'CURBSIDE',
      googlePlaceId: 'Hello World',
      latitude: 3.83,
      longitude: 64.46,
      name: 'Hello World',
      notes: 'Hello World',
    },
  },
};

export const deliveryRestaurantQueryMock: ExecutionResult<DeliveryRestaurantQuery> =
  { data: { locationByAddress: { __typename: 'InvalidInput', status: 38 } } };

export const AddressDocument = gql`
  query Address($addressId: ID!) {
    address(addressId: $addressId) {
      id
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;

export function useAddressQuery(
  options: Omit<Urql.UseQueryArgs<AddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AddressQuery, AddressQueryVariables>({
    query: AddressDocument,
    ...options,
  });
}
export const DeliveryRestaurantDocument = gql`
  query DeliveryRestaurant($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          ...RestaurantMenu
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
  ${RestaurantMenuFragmentDoc}
`;

export function useDeliveryRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    DeliveryRestaurantQuery,
    DeliveryRestaurantQueryVariables
  >({ query: DeliveryRestaurantDocument, ...options });
}
